<h3>Suspended Emails</h3>
<br />
<div>
  <input
    type="text"
    [(ngModel)]="emailFilter"
    placeholder="{{ 'label.Email' | translate }}"
    style="margin-right: 2em"
  />
  <span>{{ 'label.Type' | translate }} </span>
  <select [(ngModel)]="userTypeFilter">
    <option selected></option>
    <option *ngFor="let item of userTypes" [value]="item.value">
      {{ item.label }}
    </option>
  </select>
  <p-button
    type="button"
    class="ui-button-secondary top-left"
    (click)="onFilter()"
    label="{{ 'label.Filter' | translate }}"
    style="margin-left: 1em"
  ></p-button>
</div>
<br />
<p-table
  [value]="emails"
  [lazy]="true"
  showGridlines
  (onLazyLoad)="onLoad($event)"
  [totalRecords]="totalCount"
  [paginator]="true"
  [rows]="pageSize"
>
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'Email'">
        {{ 'label.Email' | translate }}
        <p-sortIcon [field]="'Email'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'SuspendType'">
        Suspend type <p-sortIcon [field]="'SuspendType'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'BounceType'">
        Bounce type <p-sortIcon [field]="'BounceType'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'BounceSubType'">
        Bounce sub type <p-sortIcon [field]="'BounceSubType'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'ComplaintType'">
        Complaint type <p-sortIcon [field]="'ComplaintType'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'UserType'">
        <p-sortIcon [field]="'UserType'"></p-sortIcon>
      </th>
      <th style="width: 40px"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-email>
    <tr
      [ngClass]="{
        'row-highlight': email.isHighlighted
      }"
    >
      <td>{{ email.emailAddress }}</td>
      <td>{{ email.suspendType }}</td>
      <td>{{ email.bounceType }}</td>
      <td>{{ email.bounceSubType }}</td>
      <td>{{ email.complaintType }}</td>
      <td>
        <p *ngIf="email.jobseekerId">
          <a [routerLink]="['/jobseekers/edit', email.jobseekerId]">{{
            'label.Jobseeker' | translate
          }}</a>
        </p>
        <p *ngIf="email.customerAgentId">
          {{ 'label.CustomerAgent' | translate }}
        </p>
        <p *ngIf="email.subscriberId">{{ 'label.Subscriber' | translate }}</p>
      </td>
      <td>
        <p-button
          type="button"
          (click)="onProcessClick(email)"
          icon="fa fa-check"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
